import React from 'react';
import styled from 'styled-components';
import { CheckIcon } from '../../../assets';
import { theme } from '../../../theme';

export type SelectCardCheckboxProps = {
  checked: boolean;
};

const Checkbox = styled.span<{ checked: boolean }>`
  align-items: center;
  align-self: center;
  background-color: ${({ checked }) =>
    !checked
      ? theme.colors.neutrals.solidGrays[8]
      : theme.colors.primary.white};
  border-radius: 100%;
  box-sizing: border-box;
  display: flex;
  width: 32px;
  height: 32px;
  justify-content: center;

  ${({ checked }) =>
    checked
      ? `box-shadow: 0 2px 4px 0 ${theme.colors.neutrals.solidGrays[6]};`
      : `border: 1px solid ${theme.colors.neutrals.solidGrays[6]};`}
`;

const Check = styled(CheckIcon)<{ checked: boolean }>`
  ${({ checked }) => !checked && `display: none;`}
  fill: ${theme.colors.primary.graysBlue};
  width: 22px;
`;

export const SelectCardCheckbox: React.FC<SelectCardCheckboxProps> = ({
  checked,
  ...props
}) => (
  <Checkbox checked={checked} {...props}>
    <Check checked={checked} />
  </Checkbox>
);
